(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mfa-shared-style"] && !Shopify.designMode) return;
  try {
    (() => {
  const initGuide = () => {
    const dialog = document.querySelector('.mfa-guide-dialog');
    const launcher = document.querySelector('[data-open-maggie]');
    if (!dialog || !launcher || launcher.dataset.bound) return;
    launcher.dataset.bound = 'true';
    launcher.addEventListener('click', () => { dialog.showModal(); document.body.classList.add('mfa-guide-open'); });
    dialog.querySelector('[data-close-maggie]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('close', () => { document.body.classList.remove('mfa-guide-open'); launcher.focus(); });
    dialog.addEventListener('click', event => {
      if (event.target === dialog) { const b = dialog.getBoundingClientRect(); if (event.clientX < b.left || event.clientX > b.right || event.clientY < b.top || event.clientY > b.bottom) dialog.close(); }
      const choice = event.target.closest('[data-maggie-choice]');
      if (!choice) return;
      dialog.querySelectorAll('[data-maggie-choice]').forEach(button => button.setAttribute('aria-pressed', String(button === choice)));
      dialog.querySelectorAll('[data-maggie-answer]').forEach(answer => { answer.hidden = answer.dataset.maggieAnswer !== choice.dataset.maggieChoice; });
    });
  };
  const syncSteamer = variantId => {
    document.querySelectorAll('[data-steamer-stage]').forEach(stage => {
      if (!stage.querySelector(`[data-variant="${CSS.escape(String(variantId))}"]`)) return;
      stage.querySelectorAll('[data-variant]').forEach(frame => { frame.hidden = frame.dataset.variant !== String(variantId); });
      stage.querySelectorAll('[data-steamer-choice]').forEach(link => {
        if (link.dataset.steamerChoice === String(variantId)) link.setAttribute('aria-current', 'true');
        else link.removeAttribute('aria-current');
      });
    });
  };
  const init = () => {
    initGuide();
    document.querySelectorAll('.mfa-mobile-menu').forEach(menu => {
      if (menu.dataset.bound) return;
      menu.dataset.bound = 'true';
      menu.addEventListener('keydown', event => { if (event.key === 'Escape') { menu.open = false; menu.querySelector('summary').focus(); } });
      menu.addEventListener('click', event => { if (event.target.closest('a')) menu.open = false; });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.variantChange, event => { if (event.data?.variant?.id) syncSteamer(event.data.variant.id); });

  const scentKey = value => String(value).normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/\band\b|[&+]/g, ' ').replace(/[^a-z0-9]/g, '');
  const familyMap = {eucalyptuspeppermint:'green',rosemarylemon:'green',orangegrapefruit:'citrus',lemonverbena:'citrus',lavender:'floral',rose:'floral',vanilla:'warm',kentuckybourbon:'warm'};
  const element = (tag, className, text) => { const node = document.createElement(tag); if (className) node.className = className; if (text !== undefined) node.textContent = text; return node; };
  class MfaScentRoom extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.family = 'green';
      this.strings = JSON.parse(this.querySelector('[data-scent-strings]').textContent);
      this.status = this.querySelector('[data-scent-status]');
      this.choices = this.querySelector('[data-scent-choices]');
      this.results = this.querySelector('[data-scent-results]');
      this.search = this.querySelector('[data-scent-search]');
      this.retry = this.querySelector('[data-scent-retry]');
      this.addEventListener('click', event => {
        const family = event.target.closest('[data-family]');
        if (family) {
          this.family = family.dataset.family;
          this.style.setProperty('--scent-accent', family.dataset.color);
          this.querySelectorAll('[data-family]').forEach(button => button.setAttribute('aria-pressed', String(button === family)));
          const caption = this.querySelector('[data-family-name]');
          caption.firstChild.textContent = family.querySelector('span').firstChild.textContent;
          this.results.hidden = true;
          this.search.value = '';
          this.load().then(() => this.renderChoices()).catch(() => {});
        }
        const choice = event.target.closest('[data-scent-key]');
        if (choice) this.renderProducts(choice.dataset.scentKey);
      });
      this.search.addEventListener('input', () => { this.load().then(() => this.renderChoices()).catch(() => {}); });
      this.retry.addEventListener('click', () => { this.load().then(() => this.renderChoices()).catch(() => {}); });
      const observer = new IntersectionObserver(entries => { if (entries.some(entry => entry.isIntersecting)) { observer.disconnect(); this.load().then(() => this.renderChoices()).catch(() => {}); } }, {rootMargin:'300px'});
      observer.observe(this);
    }
    async load() {
      if (this.scents) return;
      if (this.loading) return this.loading;
      this.status.textContent = this.strings.loading;
      this.retry.hidden = true;
      this.setAttribute('aria-busy', 'true');
      this.loading = (async () => {
        const products = new Map();
        let page = 1, pages = 1, pageParam = 'page';
        do {
          const url = new URL(this.dataset.catalogUrl, location.origin);
          url.searchParams.set('section_id', 'mfa-scent-data');
          url.searchParams.set(pageParam, String(page));
          const response = await fetch(url, {credentials:'same-origin', headers:{Accept:'text/html'}});
          if (!response.ok) throw new Error('Catalog response failed');
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const payload = doc.querySelector('[data-mfa-catalog]');
          if (!payload) throw new Error('Catalog section missing');
          const data = JSON.parse(payload.textContent);
          if (!Array.isArray(data.products) || Number(data.page) !== page || !Number.isFinite(Number(data.pages))) throw new Error('Catalog data invalid');
          data.products.forEach(product => products.set(product.id, product));
          pages = Number(data.pages);
          pageParam = data.page_param || 'page';
          page += 1;
        } while (page <= pages);
        this.scents = new Map();
        products.forEach(product => {
          product.scents.forEach(scent => {
            if (!scent.name || !scent.id) return;
            const key = scentKey(scent.name);
            if (!this.scents.has(key)) this.scents.set(key, {key,name:scent.name,family:familyMap[key] || 'other',products:new Map()});
            this.scents.get(key).products.set(product.id, {...product,optionId:scent.id});
          });
        });
      })().catch(error => {
        this.status.textContent = this.strings.error;
        this.retry.hidden = false;
        throw error;
      }).finally(() => { this.loading = null; this.removeAttribute('aria-busy'); });
      return this.loading;
    }
    renderChoices() {
      if (!this.scents) return;
      const query = scentKey(this.search.value);
      const choices = [...this.scents.values()].filter(scent => (this.family === 'all' || scent.family === this.family) && scentKey(scent.name).includes(query)).sort((a,b) => a.name.localeCompare(b.name));
      this.choices.replaceChildren();
      this.status.textContent = choices.length ? '' : this.strings.empty;
      choices.forEach(scent => {
        const button = element('button'); button.type = 'button'; button.dataset.scentKey = scent.key; button.setAttribute('aria-pressed','false');
        const title = element('span','',scent.name); title.append(element('small','',`${scent.products.size} ${scent.products.size === 1 ? this.strings.product : this.strings.products}`));
        const arrow = element('span','','→'); arrow.setAttribute('aria-hidden','true');
        button.append(title,arrow); this.choices.append(button);
      });
    }
    renderProducts(key) {
      const scent = this.scents?.get(key);
      if (!scent) return;
      this.choices.querySelectorAll('[data-scent-key]').forEach(button => button.setAttribute('aria-pressed',String(button.dataset.scentKey===key)));
      const story = element('div','room-scent-story');
      const heading = element('h3','',scent.name);
      const introduction = element('div'); introduction.append(heading); if(this.strings.descriptions?.[key]) introduction.append(element('p','',this.strings.descriptions[key])); introduction.append(element('p','',this.strings.selected)); story.append(introduction);
      const grid = element('div','product-grid finder-product-grid');
      scent.products.forEach(product => {
        const card = element('article','product-card product-card-dark');
        const url = new URL(product.url,location.origin); url.searchParams.set('option_values',String(product.optionId));
        const art = element('a','product-scent-art'); art.href=url.pathname+url.search; art.setAttribute('aria-label',`${product.title}: ${scent.name}`);
        art.append(element('span','scent-art-kicker',product.title),element('strong','scent-art-name',scent.name));
        const meta = element('div','product-card-meta'); const title=element('h4'); const titleLink=element('a','',product.title); titleLink.href=art.href; title.append(titleLink); meta.append(title);
        const link=element('a','add-button',this.strings.view+' →');link.href=art.href;
        card.append(art,meta,link);grid.append(card);
      });
      this.results.replaceChildren(story,grid);this.results.hidden=false;this.results.focus({preventScroll:true});
      this.results.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'start'});
    }
  }
  if (!customElements.get('mfa-scent-room')) customElements.define('mfa-scent-room',MfaScentRoom);
})();
  } catch(e) { console.error(e); }
})();

})();
